import { render } from "./RelatorioProcessosComponent.vue?vue&type=template&id=7e9eff2c&scoped=true"
import script from "./RelatorioProcessosComponent.vue?vue&type=script&lang=js"
export * from "./RelatorioProcessosComponent.vue?vue&type=script&lang=js"

import "./RelatorioProcessosComponent.vue?vue&type=style&index=0&id=7e9eff2c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e9eff2c"]])

export default __exports__